import { TypographyOptions } from '@mui/material/styles/createTypography';

export const typography: TypographyOptions = {
  htmlFontSize: 10,
  fontFamily: [
    'Roboto',
    '-apple-system',
    'BlinkMacSystemFont',
    'Helvetica Neue',
    'Arial',
    'sans-serif',
  ].join(','),
  h1: {
    fontSize: '9.6rem',
    fontWeight: 400,
    lineHeight: '1.2',
  },
  h2: {
    fontSize: '6rem',
    fontWeight: 400,
    lineHeight: '1.2',
  },
  h3: {
    fontSize: '4.8rem',
    fontWeight: 400,
    lineHeight: '1.2',
  },
  h4: {
    fontSize: '3.4rem',
    fontWeight: 400,
    lineHeight: '1.2',
  },
  h5: {
    fontSize: '2.4rem',
    fontWeight: 400,
    lineHeight: '1.2',
  },
  h6: {
    fontSize: '2rem',
    fontWeight: 400,
    lineHeight: '1.2',
  },
  subtitle1: {
    fontSize: '1.6rem',
    fontWeight: 700,
    lineHeight: '1.2',
  },
  subtitle2: {
    fontSize: '1.4rem',
    lineHeight: '1.2',
    fontWeight: 600,
  },
  body1: {
    fontSize: '1.6rem',
    fontWeight: 400,
    lineHeight: '1.2',
  },
  body2: {
    fontSize: '1.4rem',
    fontWeight: 400,
    lineHeight: '1.2',
  },
  button: {
    fontSize: '1.4rem',
    fontWeight: 500,
    letterSpacing: '1px',
  },
  caption: {
    fontSize: '1.2rem',
    fontWeight: 500,
    lineHeight: '1.2',
  },
  overline: {
    fontSize: '1rem',
    fontWeight: 400,
    lineHeight: '1.2',
  },
};
